export enum PageType {
  DOCTOR_PROFILE = 'doctor_profile',
  DOCTOR_SEARCH = 'doctor_search',
  SKILL_SEARCH = 'skill_search',
  MEDCENTER_PROFILE = 'medcenter_profile',
  MEDCENTER_SEARCH = 'medcenter_search',
  BOOKING_PAGE = 'booking_page',

  BOOKING_FRAME = 'booking_frame_page',
  BOOKING_FRAME_THANKYOU = 'booking_frame_thankyou_page',
}
